import { StyleSheet, Platform, Dimensions } from 'react-native'
import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  containerStyle: {
    marginBottom: 84,
    marginRight: 15
  },
  currencyStyle: theme => ({
    position: 'absolute',
    color: theme.colors.headerColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Platform.OS === 'ios' ? 19 : 18,
    top: Platform.OS === 'ios' ? 43 : 39,
    right: 30,
  }),
  hintNormalStyle: theme => ({
    color: theme.colors.subtitle,
    fontFamily: Fonts.type.VFFont,
    fontSize: Platform.OS === 'ios' ? 14.5 : 14,
    marginLeft: Platform.OS === 'web' && Dimensions.get('window').width > 700 ? 10 : 22,
    marginTop: -8,
  }),

  hintErrorStyle: theme => ({
    color: theme.colors.textInput.error.baseColor,
    fontFamily: Fonts.type.VFFont,
    fontSize: Platform.OS === 'ios' ? 14.5 : 14,
    marginLeft: 22,
    marginTop: -8,
  }),
  errorTriangleStyle: theme => ({
    position: 'absolute',
    top: 35,
    right: 25,
  }),
});
